/* eslint-disable max-len */
// Material----------------------------------------
export const MaterialKey = {
  M_NON_RENEWABLE_MATERIALS_USED: 'nonRenewableMaterialsUsed',
  M_RENEWABLE_MATERIALS_USED: 'renewableMaterialsUsed',
  M_TOTAL_RECYCLED_INPUT_MATERIALS_USED: 'totalRecycledInputMaterialsUsed',
  M_TOTAL_INPUT_MATERIALS_USED: 'totalInputMaterialsUsed',
  M_PRODUCT_RECLAIM_WITHIN_REPO_PERIOD:
    'productsAndTheirPackagingMaterialsReclaimedWithinTheReportingPeriod',
  M_PRODUCTS_SOLD_WITHIN_THE_REPORTING_PERIOD:
    'productsSoldWithinTheReportingPeriod',
  M_HOW_THE_DATA_FOR_RECLAIMED_PRODUCTS_HAVE_BEEN_COLLECTED:
    'howTheDataForReclaimedProductsHaveBeenCollected',
  M_TOTAL_FUEL_CONSUMPTION_FROM_NON_RENEWABLE_SOURCE:
    'totalFuelConsumptionFromNonRenewableSources',
  M_TOTAL_FUEL_CONSUMPTION_FROM_RENEWABLE_SOURCE:
    'totalFuelConsumptionFromRenewableSources'
};

export const MaterialLabel = {
  M_MATERIAL_1: 'Raw Materials used by weight or volume',
  M_MATERIAL_2: 'Recycled input materials used',
  M_MATERIAL_3: 'Reclaimed products and their packaging materials',
  M_MATERIAL_4: 'Material 4',

  M_HEADING_1: 'i. Non-renewable materials used.',
  M_HEADING_2: 'ii. Renewable materials used.',

  M_NON_RENEWABLE_MATERIALS_USED: 'Non Renewable Materials Used',
  M_RENEWABLE_MATERIALS_USED: 'Renewable Materials Used',
  M_TOTAL_RECYCLED_INPUT_MATERIALS_USED: 'Total recycled input materials used',
  M_TOTAL_INPUT_MATERIALS_USED: 'Total input materials used',
  M_PRODUCT_RECLAIM_WITHIN_REPO_PERIOD:
    'Products and their packaging material reclaimed within the reporting period',
  M_PRODUCTS_SOLD_WITHIN_THE_REPORTING_PERIOD:
    'Products sold within the reporting period',
  M_HOW_THE_DATA_FOR_RECLAIMED_PRODUCTS_HAVE_BEEN_COLLECTED:
    'How the data for this disclosure have been collected',
  M_TOTAL_FUEL_CONSUMPTION_FROM_NON_RENEWABLE_SOURCE:
    'Total fuel consumption from non-renewable sources',
  M_TOTAL_FUEL_CONSUMPTION_FROM_RENEWABLE_SOURCE:
    'Total fuel consumption from renewable sources'
};

// Energy Consumption---------------------------------------------
export const EnergyConsumptionKey = {
  EC_TOTAL_FUEL_CONSUMPTION_FROM_NON_RENEWABLE_SOURCE_TEXT:
    'totalFuelConsumptionFromNonRenewableSourcesText',
  EC_TOTAL_FUEL_CONSUMPTION_FROM_NON_RENEWABLE_SOURCE_NUMBER:
    'totalFuelConsumptionFromNonRenewableSourcesNumber',
  EC_TOTAL_FUEL_CONSUMPTION_FROM_RENEWABLE_SOURCE_TEXT:
    'totalFuelConsumptionFromRenewableSourcesText',
  EC_TOTAL_FUEL_CONSUMPTION_FROM_RENEWABLE_SOURCE_NUMBER:
    'totalFuelConsumptionFromRenewableSourcesNumber',
  EC_ENERGY_CONSUMED_IN_PRODUCTION_PROCESSES:
    'energyConsumedInProductionProcesses',
  EC_ENERGY_CONSUMED_IN_OVERHEAD: 'energyConsumedInOverhead',
  EC_NORMALISATION_FACTOR: 'normalisationFactor',
  EC_ELECTRICITY_CONSUMPTION: 'electricityCnsumption',
  EC_HEATING_CONSUMPTION: 'heatingConsumption',
  EC_COOLING_CONSUMPTION: 'coolingConsumption',
  EC_STEAM_CONSUMPTION: 'steamConsumption',
  EC_ELECTRICITY_SOLD: 'electricitySold',
  EC_HEATING_SOLD: 'heatingSold',
  EC_COOLIING_SOLD: 'coolingSold',
  EC_STEAM_SOLD: 'steamSold',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_A_TEXT:
    'totalConsumptionWithinTheOrganizationAText',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_A_NUMBER:
    'totalConsumptionWithinTheOrganizationANumber',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_B: 'totalConsumptionWithinTheOrganizationB',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_C: 'totalConsumptionWithinTheOrganizationC',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_E_TEXT:
    'totalConsumptionWithinTheOrganizationEText',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_E_NUMBER:
    'totalConsumptionWithinTheOrganizationENumber',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_F: 'totalConsumptionWithinTheOrganizationF',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_G: 'totalConsumptionWithinTheOrganizationG',
  EC_ENERGY_INTENSITY_B: 'energyIntensityB',
  EC_ENERGY_INTENSITY_C: 'energyIntensityC',
  EC_ENERGY_INTENSITY_D: 'energyIntensityD',
  EC_REDUCTION_OF_ENERGY_CONSUMPTION_A: 'reductionOfEnergyConsumptionA',
  EC_REDUCTION_OF_ENERGY_CONSUMPTION_B: 'reductionOfEnergyConsumptionB',
  EC_REDUCTION_OF_ENERGY_CONSUMPTION_C: 'reductionOfEnergyConsumptionC',
  EC_REDUCTION_OF_ENERGY_CONSUMPTION_D: 'reductionOfEnergyConsumptionD',
  EC_REDUCTIONS_ENERGY_REQUIREMENTS_OF_PRODUCTSNSERVICE_A:
    'reductionsInEnergyRequirementsOfProductsAndservicesA',
  EC_REDUCTIONS_ENERGY_REQUIREMENTS_OF_PRODUCTSNSERVICE_B:
    'reductionsInEnergyRequirementsOfProductsAndservicesB',
  EC_REDUCTIONS_ENERGY_REQUIREMENTS_OF_PRODUCTSNSERVICE_C:
    'reductionsInEnergyRequirementsOfProductsAndservicesC'
};
export const EnergyConsumptionLabel = {
  EC_ENERGY_CONSUMPTION_1: 'Energy consumption within the organization',
  EC_ENERGY_CONSUMPTION_2: 'Energy consumption outside of the organization',
  EC_ENERGY_CONSUMPTION_3: 'Energy intensity',
  EC_ENERGY_CONSUMPTION_4: 'Reduction of energy consumption',
  EC_ENERGY_CONSUMPTION_5:
    'Reductions in energy requirements of products and services',
  EC_TOTAL_FUEL_CONSUMPTION_FROM_NON_RENEWABLE_SOURCE_TEXT: '',
  EC_TOTAL_FUEL_CONSUMPTION_FROM_NON_RENEWABLE_SOURCE_NUMBER: '',
  EC_TOTAL_FUEL_CONSUMPTION_FROM_RENEWABLE_SOURCE_TEXT: '',
  EC_TOTAL_FUEL_CONSUMPTION_FROM_RENEWABLE_SOURCE_NUMBER: '',
  EC_ENERGY_CONSUMED_IN_PRODUCTION_PROCESSES:
    'Energy consumed in production processes',
  EC_ENERGY_CONSUMED_IN_OVERHEAD: 'Energy consumed in overhead',
  EC_NORMALISATION_FACTOR: 'Normalisation factor',
  EC_ELECTRICITY_CONSUMPTION: 'i. Electricity Consumption',
  EC_HEATING_CONSUMPTION: 'ii. Heating Consumption',
  EC_COOLING_CONSUMPTION: 'iii. Cooling Consumption',
  EC_STEAM_CONSUMPTION: 'iv. Steam Consumption',
  EC_ELECTRICITY_SOLD: 'i. Electricity Sold',
  EC_HEATING_SOLD: 'ii. Heating Sold',
  EC_COOLIING_SOLD: 'iii. Cooling Sold',
  EC_STEAM_SOLD: 'iv. Steam Sold',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_A_TEXT: '',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_A_NUMBER: '',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_B: '',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_C: '',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_E_TEXT: '',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_E_NUMBER: '',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_F: '',
  EC_TOTAL_CONSUMPTION_WITHIN_ORG_G: '',
  EC_ENERGY_INTENSITY_B: '',
  EC_ENERGY_INTENSITY_C: '',
  EC_ENERGY_INTENSITY_D: '',
  EC_REDUCTION_OF_ENERGY_CONSUMPTION_A: '',
  EC_REDUCTION_OF_ENERGY_CONSUMPTION_B: '',
  EC_REDUCTION_OF_ENERGY_CONSUMPTION_C: '',
  EC_REDUCTION_OF_ENERGY_CONSUMPTION_D: '',
  EC_REDUCTIONS_ENERGY_REQUIREMENTS_OF_PRODUCTSNSERVICE_A: '',
  EC_REDUCTIONS_ENERGY_REQUIREMENTS_OF_PRODUCTSNSERVICE_B: '',
  EC_REDUCTIONS_ENERGY_REQUIREMENTS_OF_PRODUCTSNSERVICE_C: ''
};

// Water and Effluents----------------------------------------
export const WaterAndEffluentsKey = {
  WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_A:
    'InteractionsWithWaterAsASharedResourceA',
  WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_B:
    'InteractionsWithWaterAsASharedResourceB',
  WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_C:
    'InteractionsWithWaterAsASharedResourceC',
  WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_D:
    'InteractionsWithWaterAsASharedResourceD',
  WE_MANAGEMENT_OF_WATER_DISCHARGE_RELATED_IMPACTS_A:
    'managementOfWaterDischargeRelatedImpactsA',
  WE_MANAGEMENT_OF_WATER_DISCHARGE_RELATED_IMPACTS_B:
    'managementOfWaterDischargeRelatedImpactsB',
  WE_MANAGEMENT_OF_WATER_DISCHARGE_RELATED_IMPACTS_C:
    'managementOfWaterDischargeRelatedImpactsC',
  WE_MANAGEMENT_OF_WATER_DISCHARGE_RELATED_IMPACTS_D:
    'managementOfWaterDischargeRelatedImpactsD',
  WE_WATER_WITHDRAWAL_SURFACE_WATER_A: 'wwSurfaceWaterA',
  WE_WATER_WITHDRAWAL_GROUND_WATER_A: 'wwGroundWaterA',
  WE_WATER_WITHDRAWAL_SEA_WATER_A: 'wwSeaWaterA',
  WE_WATER_WITHDRAWAL_PRODUCED_WATER_A: 'wwProducedWaterA',
  WE_WATER_WITHDRAWAL_THIRD_PARTY_WATER_A: 'wwThirdPartyWaterA',
  WE_WATER_WITHDRAWAL_SURFACE_WATER_B: 'surfaceWaterB',
  WE_WATER_WITHDRAWAL_GROUND_WATER_B: 'groundWaterB',
  WE_WATER_WITHDRAWAL_SEA_WATER_B: 'seaWaterB',
  WE_WATER_WITHDRAWAL_PRODUCED_WATER_B: 'producedWaterB',
  WE_WATER_WITHDRAWAL_THIRD_PARTY_WATER_B: 'thirdPartyWaterB',

  WE_BREAKDOWN_OF_TOTAL_WATER_WITHDRAWAL_FRESH_WATER:
    'breakDownOfTotalWaterWithdrawalFreshWater',
  WE_BREAKDOWN_OF_TOTAL_WATER_WITHDRAWAL_OTHER_WATER:
    'breakDownOfTotalWaterWithdrawalOtherWater',
  WE_ANY_CONTEXTUAL_INFO_TO_UNDERSTAND_DATA_COMPILATION:
    'anyContextualInfoToUnderstandDataCompilation',

  WE_TOTAL_WATER_DISCHARGE_SURFACE_WATER_A: 'wdSurfaceWaterA',
  WE_TOTAL_WATER_DISCHARGE_GROUND_WATER_A: 'wdGroundWaterA',
  WE_TOTAL_WATER_DISCHARGE_SEA_WATER_A: 'wdSeaWaterA',
  WE_TOTAL_WATER_DISCHARGE_THIRD_PARTY_WATER_A: 'wdThirdPartyWaterA',
  WE_TOTAL_WATER_DISCHARGE_FRESH_WATER_B: 'freshWaterB',
  WE_TOTAL_WATER_DISCHARGE_OTHER_WATER_B: 'otherWaterB',
  WE_TOTAL_WATER_DISCHARGE_FRESH_WATER_C: 'freshWaterC',
  WE_TOTAL_WATER_DISCHARGE_OTHER_WATER_C: 'otherWaterC',

  WE_QUESTION_1: 'weQuestion1',
  WE_QUESTION_2: 'weQuestion2',
  WE_QUESTION_3: 'weQuestion3',
  WE_QUESTION_4: 'weQuestion4',
  WE_QUESTION_5: 'weQuestion5',
  WE_QUESTION_6: 'weQuestion6',
  WE_QUESTION_7: 'weQuestion7',
  WE_QUESTION_8: 'weQuestion8'
};
export const WaterAndEffluentsLabel = {
  WE_WATER_AND_EFFLUENTS_1: 'Interactions with water as a shared resource',
  WE_WATER_AND_EFFLUENTS_2: 'Management of water discharge-related impacts',
  WE_WATER_AND_EFFLUENTS_3: 'Water withdrawal',
  WE_WATER_AND_EFFLUENTS_4: 'Total water discharge',
  WE_WATER_AND_EFFLUENTS_5: 'Water consumption',

  WE_HEADING_1:
    'i. How standards for facilities operating in locations with no local discharge requirements were determined.',
  WE_HEADING_2:
    'ii. Any internally developed water quality standards or guidelines.',
  WE_HEADING_3: 'iii. Any sector-specific standards considered.',
  WE_HEADING_4:
    'iv. Whether the profile of the receiving waterbody was considered.',
  WE_HEADING_5:
    'i. How priority substances of concern were defined, and any international standard, authoritative list, or criteria used.',
  WE_HEADING_6:
    'ii. The approach for setting discharge limits for priority substances of concern.',
  WE_HEADING_7:
    'iii. Number of incidents of non-compliance with discharge limits.',
  WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_A: '',
  WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_B: '',
  WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_C: '',
  WE_INTERACTIONS_WITH_WATER_AS_A_SHARED_RESOURCE_D: '',
  WE_MANAGEMENT_OF_WATER_DISCHARGE_RELATED_IMPACTS_A: '',
  WE_MANAGEMENT_OF_WATER_DISCHARGE_RELATED_IMPACTS_B: '',
  WE_MANAGEMENT_OF_WATER_DISCHARGE_RELATED_IMPACTS_C: '',
  WE_MANAGEMENT_OF_WATER_DISCHARGE_RELATED_IMPACTS_D: '',
  WE_WATER_WITHDRAWAL_SURFACE_WATER_A: 'i. Surface Water',
  WE_WATER_WITHDRAWAL_GROUND_WATER_A: 'ii. Ground Water',
  WE_WATER_WITHDRAWAL_SEA_WATER_A: 'iii. Sea Water',
  WE_WATER_WITHDRAWAL_PRODUCED_WATER_A: 'iv. Produced Water',
  WE_WATER_WITHDRAWAL_THIRD_PARTY_WATER_A: 'v. Third Party Water',
  WE_WATER_WITHDRAWAL_SURFACE_WATER_B: 'i. Surface Water',
  WE_WATER_WITHDRAWAL_GROUND_WATER_B: 'ii. Ground Water',
  WE_WATER_WITHDRAWAL_SEA_WATER_B: 'iii. Sea Water',
  WE_WATER_WITHDRAWAL_PRODUCED_WATER_B: 'iv. Produced Water',
  WE_WATER_WITHDRAWAL_THIRD_PARTY_WATER_B:
    'v. Third-party water, and a breakdown of this total by the withdrawal sources.',
  WE_BREAKDOWN_OF_TOTAL_WATER_WITHDRAWAL_FRESH_WATER:
    'i. Fresh Water (≤ 1,000 mg/L Total Dissolved Solids)',
  WE_BREAKDOWN_OF_TOTAL_WATER_WITHDRAWAL_OTHER_WATER:
    'ii. Other water (> 1,000 mg/L Total Dissolved Solids)',
  WE_ANY_CONTEXTUAL_INFO_TO_UNDERSTAND_DATA_COMPILATION: '',

  WE_TOTAL_WATER_DISCHARGE_SURFACE_WATER_A: 'i. Surface Water',
  WE_TOTAL_WATER_DISCHARGE_GROUND_WATER_A: 'ii. Ground Water',
  WE_TOTAL_WATER_DISCHARGE_SEA_WATER_A: 'iii. Sea Water',
  WE_TOTAL_WATER_DISCHARGE_THIRD_PARTY_WATER_A:
    'iv. Third-party water, and the volume of this total sent for use to other organizations, if applicable.',
  WE_TOTAL_WATER_DISCHARGE_FRESH_WATER_B:
    'i. Fresh water (≤ 1,000 mg/L Total Dissolved Solids).',
  WE_TOTAL_WATER_DISCHARGE_OTHER_WATER_B:
    'ii. Other water (> 1,000 mg/L Total Dissolved Solids).',
  WE_TOTAL_WATER_DISCHARGE_FRESH_WATER_C:
    'i. Fresh water  (≤ 1,000 mg/L Total Dissolved Solids).',
  WE_TOTAL_WATER_DISCHARGE_OTHER_WATER_C:
    'ii. Other water (> 1,000 mg/L Total Dissolved Solids).',

  WE_QUESTION_1: '',
  WE_QUESTION_2: '',
  WE_QUESTION_3: '',
  WE_QUESTION_4: '',
  WE_QUESTION_5: '',
  WE_QUESTION_6: '',
  WE_QUESTION_7: '',
  WE_QUESTION_8: ''
};

// biodiversity------------------------------
export const BiodiversityKey = {
  BD_QUESTION_1: 'bdQuestion1',
  BD_QUESTION_2: 'bdQuestion2',
  BD_QUESTION_3: 'bdQuestion3',
  BD_QUESTION_4: 'bdQuestion4',
  BD_QUESTION_5: 'bdQuestion5',
  BD_QUESTION_6: 'bdQuestion6',
  BD_QUESTION_7: 'bdQuestion7',
  BD_QUESTION_8: 'bdQuestion8',
  BD_QUESTION_9: 'bdQuestion9',
  BD_QUESTION_10: 'bdQuestion10',

  BD_QUESTION_11: 'bdQuestion11',
  BD_QUESTION_12: 'bdQuestion12',
  BD_QUESTION_13: 'bdQuestion13',
  BD_QUESTION_14: 'bdQuestion14',
  BD_QUESTION_15: 'bdQuestion15',
  BD_QUESTION_16: 'bdQuestion16',
  BD_QUESTION_17: 'bdQuestion17',
  BD_QUESTION_18: 'bdQuestion18',
  BD_QUESTION_19: 'bdQuestion19',
  BD_QUESTION_20: 'bdQuestion20',

  BD_QUESTION_21: 'bdQuestion21',
  BD_QUESTION_22: 'bdQuestion22',
  BD_QUESTION_23: 'bdQuestion23',
  BD_QUESTION_24: 'bdQuestion24',
  BD_QUESTION_25: 'bdQuestion25',
  BD_QUESTION_26: 'bdQuestion26',
  BD_QUESTION_27: 'bdQuestion27',
  BD_QUESTION_28: 'bdQuestion28',
  BD_QUESTION_29: 'bdQuestion29',
  BD_QUESTION_30: 'bdQuestion30',

  BD_QUESTION_31: 'bdQuestion31',
  BD_QUESTION_32: 'bdQuestion32',
  BD_QUESTION_33: 'bdQuestion33',
  BD_QUESTION_34: 'bdQuestion34',
  BD_QUESTION_35: 'bdQuestion35',
  BD_QUESTION_36: 'bdQuestion36',
  BD_QUESTION_37: 'bdQuestion37',
  BD_QUESTION_38: 'bdQuestion38',
  BD_QUESTION_39: 'bdQuestion39',
  BD_QUESTION_40: 'bdQuestion40'
};

export const BiodiversityLabel = {
  BD_BIODIVERSITY_1:
    'Operational sites owned, leased, managed in, or adjacent to, protected areas and areas of high biodiversity value outside protected areas',
  BD_BIODIVERSITY_2:
    'Significant impacts of activities, products, and services on biodiversity',
  BD_BIODIVERSITY_3:
    'Size and location of all habitat areas protected or restored',
  BD_BIODIVERSITY_4:
    'IUCN Red List species and national conservation list species with habitats in areas affected by operation',
  BD_HEADING_1: 'i. Geographic location.',
  BD_HEADING_2:
    'ii. Subsurface and underground land that may be owned, leased, or managed by the organization.',
  BD_HEADING_3:
    'iii. Position in relation to the protected area (in the area, adjacent to, or containing portions of the protected area) or the high biodiversity value area outside protected areas.',
  BD_HEADING_4:
    'iv. Type of operation (office, manufacturing or production, or extractive).',
  BD_HEADING_5:
    'v. Size of operational site in km2 (or another unit, if appropriate).',
  BD_HEADING_6:
    'vi. Biodiversity value characterized by the attribute of the protected area or area of high biodiversity value outside the protected area (terrestrial, freshwater, or maritime ecosystem).',
  BD_HEADING_7:
    'vii. Biodiversity value characterized by listing of protected status (such as IUCN Protected Area Management Categories, Ramsar Convention, national legislation).',
  BD_HEADING_8:
    'i. Construction or use of manufacturing plants, mines, and transport infrastructure.',
  BD_HEADING_9:
    'ii. Pollution (introduction of substances that do not naturally occur in the habitat from point and non-point sources).',
  BD_HEADING_10: 'iii. Introduction of invasive species, pests, and pathogens.',
  BD_HEADING_11: 'iv. Reduction of species.',
  BD_HEADING_12: 'v. Habitat conversion.',
  BD_HEADING_13:
    'vi. Changes in ecological processes outside the natural range of variation (such as salinity or changes in groundwater level).',
  BD_HEADING_14: 'i. Species affected.',
  BD_HEADING_15: 'ii. Extent of areas impacted.',
  BD_HEADING_16: 'iii. Duration of impacts.',
  BD_HEADING_17: 'iv. Reversibility or irreversibility of the impacts.',
  BD_HEADING_18: 'iii. Duration of impacts.',

  BD_QUESTION_1: '',
  BD_QUESTION_2: '',
  BD_QUESTION_3: '',
  BD_QUESTION_4: '',
  BD_QUESTION_5: '',
  BD_QUESTION_6: '',
  BD_QUESTION_7: '',
  BD_QUESTION_8: '',
  BD_QUESTION_9: '',
  BD_QUESTION_10: '',

  BD_QUESTION_11: '',
  BD_QUESTION_12: '',
  BD_QUESTION_13: '',
  BD_QUESTION_14: '',
  BD_QUESTION_15: '',
  BD_QUESTION_16: '',
  BD_QUESTION_17: '',
  BD_QUESTION_18: '',
  BD_QUESTION_19: '',
  BD_QUESTION_20: '',

  BD_QUESTION_21: '',
  BD_QUESTION_22: 'i. Critically endangered',
  BD_QUESTION_23: 'ii. Endangered',
  BD_QUESTION_24: 'iii. Vulnerable',
  BD_QUESTION_25: 'iv. Near threatened',
  BD_QUESTION_26: 'v. Least concern',
  BD_QUESTION_27: '',
  BD_QUESTION_28: '',
  BD_QUESTION_29: '',
  BD_QUESTION_30: '',

  BD_QUESTION_31: '',
  BD_QUESTION_32: '',
  BD_QUESTION_33: '',
  BD_QUESTION_34: '',
  BD_QUESTION_35: '',
  BD_QUESTION_36: '',
  BD_QUESTION_37: '',
  BD_QUESTION_38: '',
  BD_QUESTION_39: '',
  BD_QUESTION_40: ''
};

// emissions------------------------------
export const EmissionsKey = {
  E_QUESTION_1: 'eQuestion1',
  E_QUESTION_2: 'eQuestion2',
  E_QUESTION_3: 'eQuestion3',
  E_QUESTION_3_1: 'eQuestion3_1',
  E_QUESTION_4: 'eQuestion4',
  E_QUESTION_5: 'eQuestion5',
  E_QUESTION_6: 'eQuestion6',
  E_QUESTION_7: 'eQuestion7',
  E_QUESTION_8: 'eQuestion8',
  E_QUESTION_9: 'eQuestion9',
  E_QUESTION_10: 'eQuestion10',

  E_QUESTION_11: 'eQuestion11',
  E_QUESTION_12: 'eQuestion12',
  E_QUESTION_12_1: 'eQuestion12_1',
  E_QUESTION_13: 'eQuestion13',
  E_QUESTION_14: 'eQuestion14',
  E_QUESTION_15: 'eQuestion15',
  E_QUESTION_16: 'eQuestion16',
  E_QUESTION_17: 'eQuestion17',
  E_QUESTION_18: 'eQuestion18',
  E_QUESTION_19: 'eQuestion19',
  E_QUESTION_20: 'eQuestion20',

  E_QUESTION_21: 'eQuestion21',
  E_QUESTION_22: 'eQuestion22',
  E_QUESTION_22_1: 'eQuestion22_1',
  E_QUESTION_23: 'eQuestion23',
  E_QUESTION_24: 'eQuestion24',
  E_QUESTION_25: 'eQuestion25',
  E_QUESTION_26: 'eQuestion26',
  E_QUESTION_27: 'eQuestion27',
  E_QUESTION_28: 'eQuestion28',
  E_QUESTION_29: 'eQuestion29',
  E_QUESTION_30: 'eQuestion30',

  E_QUESTION_31: 'eQuestion31',
  E_QUESTION_32: 'eQuestion32',
  E_QUESTION_33: 'eQuestion33',
  E_QUESTION_34: 'eQuestion34',
  E_QUESTION_35: 'eQuestion35',
  E_QUESTION_36: 'eQuestion36',
  E_QUESTION_37: 'eQuestion37',
  E_QUESTION_38: 'eQuestion38',
  E_QUESTION_39: 'eQuestion39',
  E_QUESTION_40: 'eQuestion40',

  E_QUESTION_41: 'eQuestion41',
  E_QUESTION_42: 'eQuestion42',
  E_QUESTION_43: 'eQuestion43',
  E_QUESTION_44: 'eQuestion44',
  E_QUESTION_45: 'eQuestion45',
  E_QUESTION_46: 'eQuestion46',
  E_QUESTION_47: 'eQuestion47',
  E_QUESTION_48: 'eQuestion48',
  E_QUESTION_49: 'eQuestion49',
  E_QUESTION_50: 'eQuestion50'
};

export const EmissionsLabel = {
  E_EMISSIONS_1: 'Direct (Scope 1) GHG emissions',
  E_EMISSIONS_2: 'Energy indirect (Scope 2) GHG emissions',
  E_EMISSIONS_3: 'Other indirect (Scope 3) GHG emissions',
  E_EMISSIONS_4: 'GHG emission intensity',
  E_EMISSIONS_5: 'Reduction of GHG emissions',
  E_EMISSIONS_6: 'Emissions of ozone-depleting substances (ODS)',
  E_EMISSIONS_7:
    'Nitrogen oxides (NOX), sulfur oxides (SOX), and other significant air emissions',
  E_HEADING_1: 'i. The rationale for choosing it.',
  E_HEADING_2: 'ii. Emissions in the base year.',
  E_HEADING_3:
    'iii. The context for any significant changes in emissions that triggered recalculations of base year emissions.',
  E_HEADING_4: 'i. NOX',
  E_HEADING_5: 'ii. SOX',
  E_HEADING_6: 'iii. Persistent organic pollutants (POP)',
  E_HEADING_7: 'iv. Volatile organic compounds (VOC)',
  E_HEADING_8: 'v. Hazardous air pollutants (HAP)',
  E_HEADING_9: 'vi. Particulate matter (PM)',
  E_HEADING_10:
    'vii. Other standard categories of air emissions identified in relevant regulations',
  E_HEADING_11: 'If applicable, including:',
  E_HEADING_12: '',
  E_HEADING_13: '',

  E_QUESTION_1: '',
  E_QUESTION_2: '',
  E_QUESTION_3: '',
  E_QUESTION_3_1: 'd. Base year for the calculation',
  E_QUESTION_4: '',
  E_QUESTION_5: '',
  E_QUESTION_6: '',
  E_QUESTION_7: '',
  E_QUESTION_8: '',
  E_QUESTION_9: '',
  E_QUESTION_10: '',

  E_QUESTION_11: '',
  E_QUESTION_12: '',
  E_QUESTION_12_1: 'd. Base year for the calculation',
  E_QUESTION_13: '',
  E_QUESTION_14: '',
  E_QUESTION_15: '',
  E_QUESTION_16: '',
  E_QUESTION_17: '',
  E_QUESTION_18: '',
  E_QUESTION_19: '',
  E_QUESTION_20: '',

  E_QUESTION_21: '',
  E_QUESTION_22: '',
  E_QUESTION_22_1: 'e. Base year for the calculation',
  E_QUESTION_23: '',
  E_QUESTION_24: '',
  E_QUESTION_25: '',
  E_QUESTION_26: '',
  E_QUESTION_27: '',
  E_QUESTION_28: 'Total GHG Emissions',
  E_QUESTION_29: 'Performance Metric ( 305-3 b.)',
  E_QUESTION_30: '',

  E_QUESTION_31: '',
  E_QUESTION_32: '',
  E_QUESTION_33: '',
  E_QUESTION_34: '',
  E_QUESTION_35: '',
  E_QUESTION_36: '',
  E_QUESTION_37: '',
  E_QUESTION_38: '',
  E_QUESTION_39: '',
  E_QUESTION_40: '',

  E_QUESTION_41: '',
  E_QUESTION_42: '',
  E_QUESTION_43: '',
  E_QUESTION_44: '',
  E_QUESTION_45: '',
  E_QUESTION_46: '',
  E_QUESTION_47: '',
  E_QUESTION_48: '',
  E_QUESTION_49: '',
  E_QUESTION_50: ''
};

// wasteGenerationAndManagement----------------------------------
export const WasteGenerationAndManagementKey = {
  WGAM_QUESTION_1: 'wgamQuestion1',
  WGAM_QUESTION_2: 'wgamQuestion2',
  WGAM_QUESTION_3: 'wgamQuestion3',
  WGAM_QUESTION_4: 'wgamQuestion4',
  WGAM_QUESTION_5: 'wgamQuestion5',
  WGAM_QUESTION_6: 'wgamQuestion6',
  WGAM_QUESTION_6_1: 'wgamQuestion6_1',
  WGAM_QUESTION_6_2: 'wgamQuestion6_2',
  WGAM_QUESTION_7: 'wgamQuestion7',
  WGAM_QUESTION_8: 'wgamQuestion8',
  WGAM_QUESTION_9: 'wgamQuestion9',
  WGAM_QUESTION_10: 'wgamQuestion10',

  WGAM_QUESTION_11: 'wgamQuestion11',
  WGAM_QUESTION_12: 'wgamQuestion12',
  WGAM_QUESTION_13: 'wgamQuestion13',
  WGAM_QUESTION_14: 'wgamQuestion14',
  WGAM_QUESTION_15: 'wgamQuestion15',
  WGAM_QUESTION_16: 'wgamQuestion16',
  WGAM_QUESTION_17: 'wgamQuestion17',
  WGAM_QUESTION_18: 'wgamQuestion18',
  WGAM_QUESTION_19: 'wgamQuestion19',
  WGAM_QUESTION_20: 'wgamQuestion20',

  WGAM_QUESTION_21: 'wgamQuestion21',
  WGAM_QUESTION_22: 'wgamQuestion22',
  WGAM_QUESTION_23: 'wgamQuestion23',
  WGAM_QUESTION_24: 'wgamQuestion24',
  WGAM_QUESTION_25: 'wgamQuestion25',
  WGAM_QUESTION_26: 'wgamQuestion26',
  WGAM_QUESTION_27: 'wgamQuestion27',
  WGAM_QUESTION_28: 'wgamQuestion28',
  WGAM_QUESTION_29: 'wgamQuestion29',
  WGAM_QUESTION_30: 'wgamQuestion30',

  WGAM_QUESTION_31: 'wgamQuestion31',
  WGAM_QUESTION_32: 'wgamQuestion32',
  WGAM_QUESTION_33: 'wgamQuestion33',
  WGAM_QUESTION_34: 'wgamQuestion34',
  WGAM_QUESTION_35: 'wgamQuestion35',
  WGAM_QUESTION_36: 'wgamQuestion36',
  WGAM_QUESTION_37: 'wgamQuestion37',
  WGAM_QUESTION_38: 'wgamQuestion38',
  WGAM_QUESTION_39: 'wgamQuestion39',
  WGAM_QUESTION_40: 'wgamQuestion40'
};

export const WasteGenerationAndManagementLabel = {
  WGAM_WASTE_GENERATION_AND_MANAGEMENT_1:
    'Waste generation and significant waste-related impacts',
  WGAM_WASTE_GENERATION_AND_MANAGEMENT_2:
    'Management of significant waste-related impacts',
  WGAM_WASTE_GENERATION_AND_MANAGEMENT_3: 'Total weight of waste generated',
  WGAM_WASTE_GENERATION_AND_MANAGEMENT_4: 'Waste diverted from disposal',
  WGAM_WASTE_GENERATION_AND_MANAGEMENT_5: 'Waste directed to disposal',
  WGAM_WASTE_GENERATION_AND_MANAGEMENT_6: '',
  WGAM_WASTE_GENERATION_AND_MANAGEMENT_7: '',
  WGAM_HEADING_1:
    'i. The inputs, activities, and outputs that lead or could lead to these impacts.',
  WGAM_HEADING_2:
    'ii. Whether these impacts relate to waste generated in the organization’s own activities or to waste generated upstream or downstream in its value chain.',

  WGAM_QUESTION_1: '',
  WGAM_QUESTION_2: '',
  WGAM_QUESTION_3: '',
  WGAM_QUESTION_4: '',
  WGAM_QUESTION_5: '',
  WGAM_QUESTION_6: 'Totat weight of waste generated',
  WGAM_QUESTION_6_1: 'Waste Composition',
  WGAM_QUESTION_6_2: 'Quantity',
  WGAM_QUESTION_7: '',
  WGAM_QUESTION_8: 'Total weight of waste diverted from disposal',
  WGAM_QUESTION_8_1: 'Waste Composition',
  WGAM_QUESTION_8_2: 'Quantity',
  WGAM_QUESTION_9: 'i. Preparation for reuse',
  WGAM_QUESTION_10: 'ii. Recycling',

  WGAM_QUESTION_11: 'iii. Other recovery operations',
  WGAM_QUESTION_12: 'i. Preparation for reuse',
  WGAM_QUESTION_13: 'ii. Recycling',
  WGAM_QUESTION_14: 'iii. Other recovery operations',
  WGAM_QUESTION_15: 'i. Onsite',
  WGAM_QUESTION_16: 'ii. Offsite',
  WGAM_QUESTION_17: '',
  WGAM_QUESTION_18: 'Total weight of waste directed to disposal',
  WGAM_QUESTION_18_1: 'Waste Composition',
  WGAM_QUESTION_18_2: 'Quantity',
  WGAM_QUESTION_19: 'i. Incineration (with energy recovery)',
  WGAM_QUESTION_20: 'ii. Incineration (without energy recovery)',

  WGAM_QUESTION_21: 'iii. Landfilling',
  WGAM_QUESTION_22: 'iv. Other disposal operations',
  WGAM_QUESTION_23: 'i. Incineration (with energy recovery)',
  WGAM_QUESTION_24: 'ii. Incineration (without energy recovery)',
  WGAM_QUESTION_25: 'iii. Landfilling',
  WGAM_QUESTION_26: 'iv. Other disposal operations',
  WGAM_QUESTION_27: 'i. Onsite',
  WGAM_QUESTION_28: 'ii. Offsite',
  WGAM_QUESTION_29: '',
  WGAM_QUESTION_30: '',

  WGAM_QUESTION_31: '',
  WGAM_QUESTION_32: '',
  WGAM_QUESTION_33: '',
  WGAM_QUESTION_34: '',
  WGAM_QUESTION_35: '',
  WGAM_QUESTION_36: '',
  WGAM_QUESTION_37: '',
  WGAM_QUESTION_38: '',
  WGAM_QUESTION_39: '',
  WGAM_QUESTION_40: ''
};

// compliance----------------------------------
export const ComplianceKey = {
  C_QUESTION_1: 'cQuestion1',
  C_QUESTION_2: 'cQuestion2',
  C_QUESTION_3: 'cQuestion3',
  C_QUESTION_4: 'cQuestion4'
};

export const ComplianceLabel = {
  C_COMPLIANCE_1: 'Non-compliance with environmental laws and regulations',
  C_QUESTION_1: 'i. Total monetary value of significant fines',
  C_QUESTION_2: 'ii. Total number of non-monetary sanctions',
  C_QUESTION_3: 'iii. Cases brought through dispute resolution mechanisms',
  C_QUESTION_4: ''
};

// supplyChain----------------------------------
export const SupplyChainKey = {
  SC_QUESTION_1: 'scQuestion1',
  SC_QUESTION_2: 'scQuestion2',
  SC_QUESTION_3: 'scQuestion3',
  SC_QUESTION_4: 'scQuestion4',
  SC_QUESTION_5: 'scQuestion5',
  SC_QUESTION_6: 'scQuestion6',
  SC_QUESTION_7: 'scQuestion7',
  SC_QUESTION_8: 'scQuestion8',
  SC_QUESTION_9: 'scQuestion9'
};

export const SupplyChainLabel = {
  SC_SUPPLY_CHAIN_1:
    'New suppliers that were screened using environmental criteria',
  SC_SUPPLY_CHAIN_2:
    'Negative environmental impacts in the supply chain and actions taken',
  SC_QUESTION_1:
    'New suppliers that were screened using environmental criteria',
  SC_QUESTION_2: 'Total number of new suppliers',
  SC_QUESTION_3: '',
  SC_QUESTION_4: '',
  SC_QUESTION_5: '',
  SC_QUESTION_6:
    'Suppliers identified as having significant actual and potential negative environmental impacts with which improvements were agreed upon as a result of assessment',
  SC_QUESTION_7:
    'Total Number of suppliers identified as having significant actual and potential negative environmental impact',
  SC_QUESTION_8:
    'Suppliers identified as having significant actual and potential negative environmental impacts with which relationships were terminated as a result of assessment',
  SC_QUESTION_9:
    'Total Number of suppliers identified as having significant actual and potential negative environmental impacts'
};
